import { render, staticRenderFns } from "./ReportePedidosTotalLibrosxPeriodo.vue?vue&type=template&id=07579138"
import script from "./ReportePedidosTotalLibrosxPeriodo.vue?vue&type=script&lang=js"
export * from "./ReportePedidosTotalLibrosxPeriodo.vue?vue&type=script&lang=js"
import style0 from "./ReportePedidosTotalLibrosxPeriodo.vue?vue&type=style&index=0&id=07579138&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports